<template>
    <span
        class="inline-block px-3 py-2 border rounded"
        :class="[
            {
                'border-red-600': props.invalid,
                'border-gray-100 bg-gray-100 text-gray-500': props.disabled,
            },
        ]"
    >
        <slot></slot>
    </span>
</template>

<script setup lang="ts">
interface Props {
    invalid?: boolean;
    disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    invalid: false,
    disabled: false,
});
</script>
